module.exports = "/images/vendor/flag-icon-css/flags/1x1/as.svg?27f3e372f5d36da8c96a4eca50e6fb57";